import { apiService } from './api';
import { User } from '../types/auth';

export interface CreateUserDto {
  email: string;
  password: string;
  role: 'super_admin' | 'admin' | 'top_owner' | 'user';
  firstName?: string;
  lastName?: string;
}

export interface UpdateUserDto {
  email?: string;
  role?: 'super_admin' | 'admin' | 'top_owner' | 'user';
  firstName?: string;
  lastName?: string;
  isActive?: boolean;
}

export interface UserListQuery {
  page?: number;
  limit?: number;
  role?: string;
  isActive?: boolean;
  search?: string;
}

export interface UserListResponse {
  users: User[];
  total: number;
  page: number;
  limit: number;
}

export class UserService {
  async getUsers(query: UserListQuery = {}): Promise<UserListResponse> {
    const params = new URLSearchParams();
    
    if (query.page) params.append('page', query.page.toString());
    if (query.limit) params.append('limit', query.limit.toString());
    if (query.role) params.append('role', query.role);
    if (query.isActive !== undefined) params.append('isActive', query.isActive.toString());
    if (query.search) params.append('search', query.search);

    const response = await apiService.get<UserListResponse>(`/api/users?${params.toString()}`);
    return response.data;
  }

  async getUserById(id: string): Promise<User> {
    const response = await apiService.get<User>(`/api/users/${id}`);
    return response.data;
  }

  async createUser(userData: CreateUserDto): Promise<User> {
    const response = await apiService.post<User>('/api/users', userData);
    return response.data;
  }

  async updateUser(id: string, userData: UpdateUserDto): Promise<User> {
    const response = await apiService.put<User>(`/api/users/${id}`, userData);
    return response.data;
  }

  async deleteUser(id: string): Promise<void> {
    await apiService.delete(`/api/users/${id}`);
  }

  async activateUser(id: string): Promise<User> {
    const response = await apiService.put<User>(`/api/users/${id}/activate`);
    return response.data;
  }

  async deactivateUser(id: string): Promise<User> {
    const response = await apiService.put<User>(`/api/users/${id}/deactivate`);
    return response.data;
  }
}

export const userService = new UserService();